/* global window */
import React, {Component} from 'react';
import ReactDOM, {render} from 'react-dom';
import moment from 'moment';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
//import 'bootstrap/scss/bootstrap'; // for better fonts and form styles to demo with

import {DayPickerRangeController, DateRangePicker, DayPickerSingleDateController, SingleDatePicker} from 'react-dates';

class App extends Component {
  static getContentWidth(element) {
    const styles = getComputedStyle(element);

    return element.clientWidth
        - parseFloat(styles.paddingLeft)
        - parseFloat(styles.paddingRight)
  }

  static getContentHeight(element) {
    const styles = getComputedStyle(element);

    return element.clientHeight
        - parseFloat(styles.paddingTop)
        - parseFloat(styles.paddingBottom)
  }

  constructor(props) {
    super(props);
    const reservedDatesVar = 'destinationCalendarReservations' + props.id;
    let reservedDates = [];
    if (window[reservedDatesVar] !== undefined) {
      window[reservedDatesVar].forEach(
          (date) => reservedDates.push(
              moment(new Date(date))
          )
      );
    }
    this.state = {
      focusedInput: null,
      fullscreen: false,
      direction: 'left',
      dateFormat: 'MM/DD/YYYY',
      reservedDates,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      calendarMonthWidth: (this.props.daySize * 7) + (13 * 2),
    };

    this.updateDimensions = this.updateDimensions.bind(this);
    this.handleDatesChange = this.handleDatesChange.bind(this);
    this.handleFocusChange = this.handleFocusChange.bind(this);
    this.handleChangeFullscreen = this.handleChangeFullscreen.bind(this);
    this.handleChangeDirection = this.handleChangeDirection.bind(this);
    this.handleChangeDateFormat = this.handleChangeDateFormat.bind(this);
    this.handleIsDayHighlighted = this.handleIsDayHighlighted.bind(this);
    this.isDayBlocked = this.isDayBlocked.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.setState({
      windowWidth: App.getContentWidth(ReactDOM.findDOMNode(this).parentNode),
      windowHeight: App.getContentHeight(ReactDOM.findDOMNode(this).parentNode)
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({
      windowWidth: App.getContentWidth(ReactDOM.findDOMNode(this).parentNode),
      windowHeight: App.getContentHeight(ReactDOM.findDOMNode(this).parentNode)
    });
  };

  handleDatesChange({startDate, endDate}) {
    this.setState({startDate, endDate});
  }

  handleFocusChange(focusedInput) {
    this.setState({focusedInput});
  }

  handleChangeFullscreen() {
    this.setState({fullscreen: !this.state.fullscreen});
  }

  handleChangeDirection(e) {
    this.setState({direction: e.target.value});
  }

  handleChangeDateFormat(e) {
    this.setState({dateFormat: e.target.value});
  }

  handleIsDayHighlighted(day) {
    return this.state.reservedDates.filter(d => d.isSame(day, 'day')).length > 0;
  }

  isDayBlocked(day) {
    return this.state.reservedDates.filter(d => d.isSame(day, 'day')).length > 0;
  }

  getComponent() {
    /* eslint-disable eqeqeq */
    if (this.props.single == false) {
      return this.props.readOnly == true ? DayPickerRangeController : DateRangePicker;
    }
    return this.props.readOnly == true ? DayPickerSingleDateController : SingleDatePicker;
    /* eslint-enable eqeqeq */
  }

  shouldCalcMonths() {
    const {responsive, numberOfMonths} = this.props;
    return responsive && numberOfMonths !== 1;
  }

  getModifiedProps() {
    const {numberOfMonths, maxNumberOfMonths} = this.props;
    const {calendarMonthWidth, windowWidth} = this.state;

    let newProps = {
      ...this.props
    };

    let realNumberOfMonths = numberOfMonths;
    if (this.shouldCalcMonths()) {
      const calculatedNumberOfMonths = Math.floor(windowWidth / calendarMonthWidth);
      realNumberOfMonths = Math.min(calculatedNumberOfMonths, maxNumberOfMonths);
      if (numberOfMonths !== realNumberOfMonths) {
        newProps.numberOfMonths = realNumberOfMonths;
      }
    }

    const monthWidth = (windowWidth / realNumberOfMonths) - (15 * 2);
    newProps.daySize = Math.floor(monthWidth / 7);
    return newProps;
  }

  render() {
    let Component = this.getComponent();
    const props = this.getModifiedProps();

    return (
      <Component
        {...props}
        onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })} // PropTypes.func.isRequired,
        focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
        onFocusChange={focusedInput => this.setState({focusedInput})} // PropTypes.func.isRequired,
        initialVisibleMonth={() => moment()} // PropTypes.func or null,
        isDayHighlighted={this.handleIsDayHighlighted}
        isDayBlocked={this.isDayBlocked}
      />
    );
  }
}

App.defaultProps = {
  readOnly: true,
  hideKeyboardShortcutsPanel: true,
  numberOfMonths: 3,
  maxNumberOfMonths: 3,
  startDate: null,
  endDate: null,
  single: false,
  responsive: true,
  orientation: 'horizontal',
  daySize: 39,
};

// renders to all elements with react-calendar class
const elements = document.getElementsByClassName('react-calendar');
for (let i = 0; i < elements.length; i++) {
  const element = elements[i];
  let attributes = [];
  // element.attributes isn't a normal array
  [].forEach.call(element.attributes,(attribute) => {
    // only add data attributes to props
    if (!/^data-/.test(attribute.name)) {
      return;
    }
    // remove the data- and convert to camel case
    const attributeName = attribute.name.substring(5)
        .replace(/-([a-z])/g, g => g[1].toUpperCase());
    attributes[attributeName] = attribute.value;
  });
  render(<App {...attributes} />, element);
}

/*
var head = document.head;
var link = document.createElement("link");

link.type = "text/css";
link.rel = "stylesheet";
link.href = 'http://destinations.american-orthodontics.localhost/_resources/themes/american-ortho-destinations/dist/css/app.css?m=1578495362';

head.appendChild(link);
*/
